import { RecommenderExtendedProfile } from '@youscience/commonapp-service-common';

import { FormState } from '@constants/commonApp/types';

import {
  SchoolProfileFields,
  ClassRankFields,
  GPAFields,
  TranscriptsFields,
  SchoolDetailsCounselorFields,
} from './types';

export const updateSchoolDetailsCounselorState = (
  schoolDetailsCounselorFormState: FormState<SchoolDetailsCounselorFields>,
) => {
  const {
    data: { communityDisruption },
  } = schoolDetailsCounselorFormState;

  return {
    schoolDetails: {
      communityDisruption,
    },
  };
};

export const updateSchoolProfileState = (
  recommenderProfile: RecommenderExtendedProfile,
  schoolFormState: FormState<SchoolProfileFields>,
) => {
  if (schoolFormState.data?.courses?.offered?.charAt(0) === ',') {
    schoolFormState.data.courses.offered = schoolFormState.data.courses.offered.substring(1);
  }

  const data = {
    schoolProfile: {
      ...recommenderProfile.schoolProfile?.schoolProfile,
      ...schoolFormState.data,
      graduation: schoolFormState.data.graduation ?? undefined,
      expectedMidYear: schoolFormState.data.expectedMidYear ?? undefined,
    },
  };

  return data;
};

export const updateClassRankState = (classRankFormState: FormState<ClassRankFields>) => {
  return {
    classRank: {
      ...classRankFormState.data,
    },
  };
};

export const updateGPARankState = (gpaFormState: FormState<GPAFields>) => {
  return {
    gpa: {
      ...gpaFormState.data,
    },
  };
};

export const updateTranscriptsState = (transcriptsFormState: FormState<TranscriptsFields>) => {
  return {
    transcripts: {
      ...transcriptsFormState.data,
    },
  };
};
